import type { IVideoEditor } from '@src/editor/interface/IVideoEditor';

/**
 * Canonical top-level timeline elements for translation extraction.
 *
 * Reads straight off the editor via `timeline.toStoredJSON()` rather than
 * `VideoSourceStore.source`. The source store holds the *preview*
 * serialization (`toPreviewJSON` + `applyWindowingFilter`): when windowing is
 * active it drops every element outside the current playhead window, and it
 * reshuffles track order (`moveLayoutTracksToBottom` / `assignZIndexFromTrack`).
 * Feeding that into `extractTranslatableElements` would silently miss
 * windowed-out compositions and see a track order that doesn't match the
 * editor.
 *
 * `toStoredJSON()` runs no LayoutEngine, keeps original track numbering, and
 * emits every authored element — the correct basis for collecting translation
 * targets. Pass the result as `videoSourceElements`.
 */
export function getTranslatableSourceElements(
  editor: IVideoEditor | null | undefined,
): ReadonlyArray<Record<string, unknown>> | undefined {
  return editor?.timeline.toStoredJSON().elements;
}
